var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileblue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.13904 0C5.50428 0 3.36839 2.12665 3.36839 4.75C3.36839 7.37335 5.50428 9.5 8.13904 9.5C10.7738 9.5 12.9097 7.37335 12.9097 4.75C12.9097 2.12665 10.7738 0 8.13904 0Z",
    fill: "#004CBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.126 11C2.49124 11 0.355347 13.1266 0.355347 15.75C0.355347 18.3734 2.49124 20.5 5.126 20.5H11.1521C13.7868 20.5 15.9227 18.3734 15.9227 15.75C15.9227 13.1266 13.7868 11 11.1521 11H5.126Z",
    fill: "#004CBC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileblue);
export default __webpack_public_path__ + "static/media/profileblue.822177ced0c63267bc1dc1975cdfee95.svg";
export { ForwardRef as ReactComponent };